// src/client/pages/order-cancelled.jsx
import React from 'react';

const OrderCancelled = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>❌ Paiement annulé</h1>
    <p>Vous pouvez réessayer votre commande à tout moment.</p>
  </div>
);

export default OrderCancelled;
